<template>

    <div>
        <team-form
            v-if="team !== null"
            box-title="Team bewerken"
            @updateTeamData="$emit('updateTeamData')"
            :team="team"
        ></team-form>

        <team-form
            v-else
            box-title="Team toevoegen"
            @updateTeamData="$emit('updateTeamData')"
        ></team-form>

        <team-membership
            v-if="team !== null"
            :team="team"
        ></team-membership>
    </div>

</template>

<script>

import { mapGetters } from "vuex";
import TeamForm from "../../../components/HR/Teams/TeamForm";
import TeamMembership from "../../../components/HR/Teams/TeamMembership";

export default {

    components: {
        TeamForm,
        TeamMembership,
    },

    computed: {
        ...mapGetters([
            'getHrTeam',
        ]),

        team() {
            if (!this.$route.params.id) {
                return null;
            }

            return this.getHrTeam;
        },
    },

    metaInfo: {
        title:'Team form',
    },

    name:'HrTeamsForm',

}

</script>
